<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :options="[{ type: 'alert', label: '알림 대상자 선택' }]"
    />

    <!-- 위험성 평가 대상 안전보건 위험정보 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="위험성 평가 대상 안전보건 위험정보"
      :tableData="[
         { id: 'no', title: 'No.', type: 'no', width: '80px' },
        { id: 'cell1', title: '위험성 평가 대상 안전보건 위험정보', type: 'textarea', placeholder: '내용' },
        { id: 'cell1', title: '세부작업\n(작업순서)', type: 'textarea', placeholder: '내용' },
        { id: 'cell2', title: '세부작업설명', type: 'textarea', placeholder: '내용' },
        { id: 'cell3', title: '기계·기구 또는 설비', type: 'textarea', placeholder: '내용' },
        { id: 'cell4', title: '유해인자', type: 'textarea', placeholder: '내용' },
      ]"
      v-model="form.tableList"
    />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableCustom from "@/components/TableCustom.vue";

export default {
  components: {
    TableCustom,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        tableList: [],
      },
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss">
</style>
